// Per-chain tx-explorer link builders. Used by ResultCard.

import type { Network } from "@/config/network";
import { chains } from "@/config/chains";

export function nearExplorerTx(network: Network, hash: string): string {
  return network === "mainnet"
    ? `https://nearblocks.io/txns/${hash}`
    : `https://testnet.nearblocks.io/txns/${hash}`;
}

export function evmExplorerTx(network: Network, chainId: number, hash: string): string | undefined {
  const bundle = chains(network);
  const entry = Object.values(bundle.evm).find((c) => c.id === chainId);
  return entry ? `${entry.explorer}/tx/${hash}` : undefined;
}

export function solExplorerTx(network: Network, signature: string): string {
  const bundle = chains(network);
  const params = bundle.solana.cluster === "mainnet-beta" ? "" : "?cluster=devnet";
  return `${bundle.solana.explorer}/tx/${signature}${params}`;
}

export function fogoExplorerTx(network: Network, signature: string): string {
  return `${chains(network).fogo.explorer}/tx/${signature}`;
}

export function starknetExplorerTx(network: Network, hash: string): string {
  return `${chains(network).starknet.explorer}/tx/${hash}`;
}
